
define('text!templates/modules/calendar/calendar/calendar-component/item/calendar-add-item-today.html',[],function () { return '<div class="add-calendar-item-container">\n    <div class="add-calendar-item-button">\n        <span class="add-calendar-item-icon"><i class="fa fa-plus"></i></span>\n        <div class="menu-options"></div>\n    </div>\n</div>\n';});

